import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../../SGRE-shared/constants/app-constant';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { HomePageConstants } from '../../models/homepage.model';
import { HomepageService } from '../../services/homepage.service';
import { itemState } from '../../store/homepage.state';

@Component({
  selector: 'app-homepage-category-section3',
  templateUrl: './homepage-category-section3.component.html',
  styleUrl: './homepage-category-section3.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomepageCategorySection3Component implements OnInit {

  public categoryList$: Observable<itemState[]>;
  // public imageUrl: any = environment.siteUrls.getBackofficeUrl.slice(0, -1);
  // plpUrl = AppConstants.routeUrls.plp;
  // categoriesName: string = ':name-asc:allCategories:';

  constructor(
    private homepageService: HomepageService,
    private router: Router,
    private storageService: StorageService
  ) { }

  //////ootb implementation/////////////////////////////
  ngOnInit(): void {
    this.fetchCategoriesList();
    this.getFetchedCategories();
  }

  fetchCategoriesList(): void {
    this.homepageService.getCategoriesAPI();
  }
  getFetchedCategories(): void {
    this.categoryList$ = this.homepageService.getCategories();
  }

  // LATEST CODE
  categoryClick(categoryName?: string): void {
    const categoriesName: string = HomePageConstants.ALL_CATEGORIES;
    const queryText = (categoryName?.length > 0) ? (categoriesName + `"${categoryName}"`) : null;
    this.storageService.query = queryText;
    this.router.navigate([AppConstants.routeUrls.plp]);
  }

  // categoryClick(categoryName?: string): void {
  //   const categoriesName: string = HomePageConstants.ALL_CATEGORIES;

  //   if (categoryName?.length > 0) {
  //     const queryText = categoriesName + `"${categoryName}"`;
  //     this.productsService.setQueryToStorage(queryText);
  //   } else {
  //     this.productsService.removeQueryFromStorage();
  //   }
  //   this.router.navigate([AppConstants.routeUrls.plp]);
  // }

  ////old implementation////////////////////
  // ngOnInit(): void {
  //   this.getCategoriesList();
  // }

  // public getCategoriesList() {
  //   this.homepageService.getCategoriesAPI();
  //   this.categoryList$ = this.homepageService.dataCat$;
  // }

  // getImageUrl(imgArr: any[]) {
  //   return imgArr && imgArr.length > 0 && environment.siteUrls.getBackofficeUrl + imgArr[0].url;
  // }

  // categoryClick(categoryName?: string) {
  //   if (categoryName?.length > 0) {
  //     let str = this.categoriesName + `"${categoryName}"`;
  //     this.store.dispatch(StorageActions.setQuery({ query: str }));
  //   } else {
  //     this.store.dispatch(StorageActions.setQuery({ query: '' }));
  //     this.storageService.resetQuery();
  //   }
  //   this.router.navigate([AppConstants.routeUrls.plp]);
  // }
}
